module.exports = __webpack_public_path__ + "static/media/r_itdot_14.6a036f64.png";